module.exports = __webpack_public_path__ + "static/img/cont44_04.0d3c8b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_04.jpg
// module id = 6obT
// module chunks = 0